module.exports = __webpack_public_path__ + "b02bdc1b846fd65473922f5f62832108.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@element-ui/lib/theme-default/fonts/element-icons.ttf?t=1472440741
// module id = 48
// module chunks = 1